import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'

import colors from '../../../lib/Colors'

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`
const Block = styled.div`
  background: ${colors.gray_400};
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  margin: ${({ margin }) => margin || '0px'};
  border-radius: ${({ radius }) => radius || '1px'};
  background-image: linear-gradient(
    to right,
    ${colors.gray_400} 0%,
    ${colors.gray_1000} 20%,
    ${colors.gray_400} 40%,
    ${colors.gray_400} 100%
  );
  background-repeat: no-repeat;
  background-size: ${({ height }) => `1200px ${height}`};
  display: inline-block;
  position: relative;
  animation-duration: 3s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${shimmer};
  animation-timing-function: linear;
`

const ShimmerBlock = ({ width, height, radius, margin }) => {
  return (
    <>
      <Block height={height} margin={margin} radius={radius} width={width} />
    </>
  )
}

ShimmerBlock.propTypes = {
  height: PropTypes.string.isRequired,
  margin: PropTypes.string,
  radius: PropTypes.string,
  width: PropTypes.string.isRequired,
}

export default ShimmerBlock
